import clsx from 'clsx'

import AppleMusicIcon from './icons/AppleMusicIcon'
import SoundCloudIcon from './icons/SoundCloudIcon'
import SpotifyIcon from './icons/SpotifyIcon'
import TikTokIcon from './icons/TikTokIcon'
import VimeoIcon from './icons/VimeoIcon'
import YouTubeIcon from './icons/YouTubeIcon'
import styles from './StreamingServiceIcon.module.css'
import { StreamingServiceIconProps } from './StreamingServiceIcon.types'

const StreamingServiceIcon = ({
	className,
	service,
	...props
}: StreamingServiceIconProps): JSX.Element => {
	return (
		<span
			className={clsx(styles.icon, className)}
			data-testid={service}
			{...props}
		>
			{service === 'appleMusic' && <AppleMusicIcon />}
			{service === 'soundCloud' && <SoundCloudIcon />}
			{service === 'spotify' && <SpotifyIcon />}
			{service === 'tikTok' && <TikTokIcon />}
			{service === 'vimeo' && <VimeoIcon />}
			{service === 'youTube' && <YouTubeIcon />}
		</span>
	)
}

export default StreamingServiceIcon
